import React, {PropTypes} from 'react';
import Tags from '../Tags/Tags';
import SocialShare from '../SocialShare/SocialShare';

const s = require('./singleArticle.scss');

const SingleArticle = ({date, title, content, links, itemDeepLink, customClass}) => {
  return (
    <li data-hook="article-container" className={`${s.gridItem} ${customClass}`}>
      <label className={s.date} data-hook="article-date">{date}</label>
      <h2 className={s.title} data-hook="single-article-title">{title}</h2>
      <div data-hook="article-content">{content}</div>
      <hr className={s.hr}/>
      <div data-hook="article-tags-wrapper" className={s.itemFooter}>
        <SocialShare data-hook="post-social-shares" link={itemDeepLink}/>
        <Tags data-hook="article-labels" links={links}/>
      </div>

    </li>
  );
};

SingleArticle.propTypes = {
  date: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  content: PropTypes.object.isRequired,
  itemDeepLink: PropTypes.string.isRequired,
  customClass: PropTypes.string,
  links: PropTypes.array.isRequired
};

export default SingleArticle;



// WEBPACK FOOTER //
// ./components/partial/SingleArticle/SingleArticle.js